export default __webpack_public_path__ + "static/media/tilt.c8185760.svg";